export default __webpack_public_path__ + "static/media/dell.29081381.png";